import styled from '@emotion/styled';

import { theme } from '@ublend-npm/aulaui-next';

const { blackOpacity12 } = theme.color.designSystem;

export const CategoryTitle = styled.h3`
  font-family: ${theme.font.family.workSans};
  font-weight: ${theme.font.weight.semiBold};
  font-size: ${theme.font.size.large};
  line-height: ${theme.font.lineHeight.large};
  margin: ${theme.spacing.large} 0 ${theme.spacing.small} 0;
`;

export const TemplatesDrawerContainer = styled.div`
  display: flex;
  overflow: hidden;
  height: 100%;

  // medium devices
  @media (min-width: 768px) {
    width: 700px;
  }

  // large devices
  @media (min-width: 992px) {
    width: 929px;
  }

  // x-large devices
  @media (min-width: 1200px) {
    width: 1129px;
  }
`;

export const TemplatesTitle = styled.h2`
  font-family: ${theme.font.family.workSans};
  font-weight: ${theme.font.weight.semiBold};
  font-size: 20px;
  line-height: ${theme.font.lineHeight.large};
  padding-bottom: ${theme.spacing.xxGiant};
`;

export const TemplatesListContainer = styled.section`
  flex: 0 0 409px;
  flex-direction: column;
  align-items: center;
  overflow-y: scroll;
  padding: ${theme.spacing.large};
`;

export const TemplatesListContainerInner = styled.div`
  width: 100%;
`;
export const ActionButtonsContainer = styled.div`
  position: sticky;
  bottom: 0;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid;
  border-color: ${blackOpacity12};
  padding: ${theme.spacing.small} ${theme.spacing.medium};
  flex-wrap: wrap;
  gap: ${theme.spacing.medium};
  background-color: white;
`;
